(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lemora-product"] && !Shopify.designMode) return;
  try {
    
function initLemora(scope){
 scope.querySelectorAll('[data-lemora-section]').forEach(section=>{
  if(section.dataset.ready)return;
  section.dataset.ready='true';
  const image=section.querySelector('.lm-hero-image');
  const showImage=(src,alt,infographic=false)=>{
   if(!image||!src)return;
   section.querySelector('.lm-image-main').classList.toggle('lm-show-infographic',infographic);
   image.removeAttribute('srcset');image.src=src;image.alt=alt||'';
  };
  section.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>showImage(button.dataset.image,button.querySelector('img')?.alt,button.dataset.infographic==='true')));
  const radios=section.querySelectorAll('[data-variant-radio]');
  const sticky=section.querySelector('[data-sticky-shop]'),buy=section.querySelector('.lm-buy-row');
  section.querySelector('[data-pick-shade]')?.addEventListener('click',()=>section.querySelector('.lm-shades')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'}));
  if(sticky&&buy&&'IntersectionObserver' in window){new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting;},{threshold:0}).observe(buy);}

  const selectVariant=(choice,updateUrl=true)=>{
   const button=section.querySelector('[data-add]');
   if(button){button.disabled=choice.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.ready;}
   section.querySelector('.lm-price').textContent=choice.dataset.price; const stickyPrice=section.querySelector('[data-sticky-price]');if(stickyPrice)stickyPrice.textContent=choice.dataset.price;
   const compare=section.querySelector('[data-compare-price]');
   const badge=section.querySelector('[data-sale-badge]');
   const regular=Number(choice.dataset.compareCents), sale=Number(choice.dataset.priceCents);
   const discounted=regular>sale;
   if(compare){compare.hidden=!discounted;compare.textContent=choice.dataset.compareFormatted;}
   if(badge){badge.hidden=!discounted;badge.textContent=discounted?Math.round((regular-sale)*100/regular)+'% '+choice.dataset.saleLabel:'';}
   section.querySelector('[data-shade-name]').textContent=choice.dataset.title;
   showImage(choice.dataset.photo,choice.dataset.alt);
   if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',choice.value);history.replaceState({},'',url);}
  };
  radios.forEach(radio=>radio.addEventListener('change',()=>{if(radio.checked)selectVariant(radio);}));
  window.addEventListener('popstate',()=>{
   const id=new URL(location.href).searchParams.get('variant');
   const choice=Array.from(radios).find(radio=>radio.value===id)||radios[0];
   if(choice){choice.checked=true;selectVariant(choice,false);}
  });
 });
}
initLemora(document);
document.addEventListener('shopify:section:load',event=>initLemora(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
